import {useVerificationSettings as useSharedVerificationSettings} from '@chekin/shared/guest-form';
import {useGuestGroup} from 'hooks';

export function useVerificationSettings(housingId?: string) {
  const {guestGroup} = useGuestGroup();
  return useSharedVerificationSettings({housingId, guestGroup});
}
